import React, { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { AnimatePresence } from 'framer-motion';
import './i18n/config';

// Components
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
import ProductCatalog from './components/ProductCatalog';
import ProcessSection from './components/ProcessSection';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';
import ContactSection from './components/ContactSection';
import QuoteModal from './components/QuoteModal';
import PromotionBanner from './components/PromotionBanner';
import BackgroundTexture from './components/BackgroundTexture';
import PageLoader from './components/PageLoader';
import AdminApp from './admin/AdminApp';

// Simple path-based routing — no react-router needed
const isAdminRoute = window.location.pathname.startsWith('/admin');

function App() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  // Show the intro loader only once per browser session, not on every reload/navigation
  const [appReady, setAppReady] = useState(
    () => sessionStorage.getItem('eudora_intro_shown') === 'true'
  );

  if (isAdminRoute) return <AdminApp />;

  const openQuoteModal = () => setIsQuoteModalOpen(true);
  const closeQuoteModal = () => setIsQuoteModalOpen(false);

  return (
    <>
      <AnimatePresence>
        {!appReady && (
          <PageLoader
            onDone={() => {
              sessionStorage.setItem('eudora_intro_shown', 'true');
              setAppReady(true);
            }}
          />
        )}
      </AnimatePresence>

      {appReady && (
        <div className="App">
      {/* Background Texture */}
      <BackgroundTexture />
      
      {/* Toast Notifications */}
      <Toaster
        position="top-center"
        containerStyle={{ top: 88 }}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#F5F5DC',
            color: '#3E2723',
            border: '1px solid #2E7D32',
            maxWidth: '90vw',
            fontSize: '14px',
          },
          success: {
            iconTheme: {
              primary: '#2E7D32',
              secondary: '#F5F5DC',
            },
          },
          error: {
            iconTheme: {
              primary: '#F44336',
              secondary: '#F5F5DC',
            },
          },
        }}
      />

      {/* Header */}
      <Header />

      {/* Promotion Banner */}
      <PromotionBanner onQuoteClick={openQuoteModal} />

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <HeroSection onQuoteClick={openQuoteModal} />

        {/* Story Section */}
        <StorySection />

        {/* Product Catalog */}
        <ProductCatalog onQuoteClick={openQuoteModal} />

        {/* Process Section */}
        <ProcessSection />

        {/* Contact Section */}
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating CTA */}
      <FloatingCTA onClick={openQuoteModal} />

      {/* Quote Modal */}
      <QuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
    </div>
      )}
    </>
  );
}

export default App;